import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { useOutsideClick } from 'hooks/useOutsideClick';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';

import { CvvTooltip } from './CvvTooltip';

import styles from './cvvInput.module.sass';

type PropTypes = {
  value?: string;
  error?: string;
  isBright?: boolean;
  errorTextMarginLeft?: string;
  onChange?: (newValue: string) => void;
};

export const CvvInput: React.FC<PropTypes> = ({
  value,
  error,
  isBright,
  errorTextMarginLeft,
  onChange,
}) => {
  const { t } = useTranslation('common');
  const [isTooltipShown, setIsTooltipShown] = useState(false);
  const outsideClickRef = useOutsideClick(() => setIsTooltipShown(false));

  return (
    <>
      <div className={cx(styles.wrapper, { [styles.bright]: isBright })}>
        <label className={styles.label}>
          <div className={styles.labelText}>{t('securityNumber')}</div>

          <input
            value={value}
            type="number"
            placeholder="CVV2"
            className={styles.input}
            onChange={(e) => onChange && onChange(e.target.value)}
          />
        </label>

        <div ref={outsideClickRef} className={styles.tooltipWrapper}>
          {isTooltipShown && (
            <div className={styles.tooltip} role="tooltip">
              <CvvTooltip />
            </div>
          )}

          <BaseButton
            type={ButtonTypes.Transparent}
            onClick={() => setIsTooltipShown(true)}
            onMouseEnter={() => setIsTooltipShown(true)}
            onMouseLeave={() => setIsTooltipShown(false)}
            ariaLabel="Info"
          >
            <InfoIcon className={styles.icon} />
          </BaseButton>
        </div>
      </div>

      {error && (
        <p className={styles.error} style={{ marginLeft: errorTextMarginLeft }}>
          {error}
        </p>
      )}
    </>
  );
};
